import { BRANCH_FORBIDDEN_CODE } from "~/shared/constants/auth";

/**
 * "이 매장에 접근할 권한이 없다"는 응답인지 판별.
 *
 * 레거시 백엔드는 로그인 만료에도 403 을 쓰기 때문에 상태 코드만으로는 구분할 수 없다.
 * 백엔드가 body 의 `code` 로 구분해서 내려준다(common/permissions.py HasBranchAccess).
 */
export function isBranchForbiddenError(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: { code?: string } } })?.response;
  return response?.status === 403 && response?.data?.code === BRANCH_FORBIDDEN_CODE;
}
